// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1pPOd","productName":"Table_productName__3ktzj"};